






































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import { summaryReport } from "@/api/recharge";
import axios from "axios";
import config from "@/config/default";
import filterTime from "@/utils/filterTime";


@Component
export default class Header extends Mixins(Loading, tablePagination) {
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;
  @Prop() status!: string;
  activeName:string="全部";
  options: Array<{ id: number | string; name: string }> = [
    {
      id: "",
      name: "全部",
    },
    {
      id: 0,
      name: "未到账",
    },
    {
      id: 1,
      name: "已到账",
    },
    {
      id: 2,
      name: "支付失败",
    },
  ];

  handleClick(tab: any, event: any) {
    this.$emit("statueValue",tab.$el.id);
  }

  mounted() {
    this.getData();

  }
  getData() {
  }

  // 导出excel
  importExcel() {
    this.showLoading();
    axios({
      // 指定请求方式
      method: "get",
      url: config.baseUrl + "/sysCharge/excel/exportUmsMemberCharge",
      // 请求类型为blob
      responseType: "blob",
      withCredentials: true, // 允许附带cookit
      headers: {
        Authorization: this.$store.getters.token, // 附带的token
      },
      params: {
        fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
        toDate: this.fromDate && this.fromDate.toString().split(",")[1],
        shopName: this.shopName,
        phone: this.phone,
        status: this.status,

      },
    })
            .then((res) => {
              let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); // res就是接口返回的文件流了
              let objectUrl = URL.createObjectURL(blob);
              let a = document.createElement("a");
              let time = filterTime(Date.now());
              console.log(time);
              a.setAttribute("href", objectUrl);
              a.setAttribute("download", `养博城后台充值${time}.xls`);
              a.click();
              this.hideLoading();
            })
            .catch((err) => {
              this.hideLoading();
              this.$message.error(err);
            });
  }
}
